import { IActivityType, IProperty } from 'models/Analytics'
import { CHLastLoad, getSessionId } from './sessions'

export interface Event {
  sessionId?: string;
  authenticated: boolean;
  text: string;
  targetLocation?: string;
  modalType?: string;
  category: string;
  activity: IActivityType;
  url: string;
  language: string;
  title: string;
  sendToTealium: boolean;
  sendToCoreAPI: boolean;
  isMessageCenter: boolean;
  heading?: string;
  subheading?: string;
  element?: string;
  messageStatus?: string;
  messageSubject?: string;
  eventName?: 'message_center_dropdown_click' | 'message_center_message_modal_click' | 'message_center_my_messages_click';
  messageComponent?: 'my messages' | 'dropdown' | 'message modal';
  property?: IProperty; // Defaults to MAX on core api events
  component?: string; // Defaults to Header on core api events
  messageId?: string;
  profileId?: string;
  /** used to send some event data only to core */
  core?: {
    profileId?: string
    messageId?: string
  }
}

export const sessionId = getSessionId()

export interface Subscriber {
  next: (event: Event) => void;
  error: (error: Error) => void;
  complete: () => void;
  unsubscribe: () => void;
}

const events: Event[] = []
const subscribers: Subscriber[] = []

function publish (event: Event) {
  const eventWithSessionId: Event = { ...event, sessionId }
  events.push(eventWithSessionId)
  localStorage.setItem(CHLastLoad, new Date().toDateString())

  subscribers.forEach((subscriber) => {
    subscriber.next(eventWithSessionId)
  })
}

interface SubscribeConfig {
  next: (event: any | Event) => void;
  error?: (error: Error) => void;
  complete?: () => void;
}

function subscribe (config: SubscribeConfig) {
  const noop = () => null

  const subscription: Subscriber = {
    next: config.next,
    error: config.error || noop,
    complete: config.complete || noop,
    unsubscribe: () => {
      const subscriptionIndex = subscribers.indexOf(subscription)
      subscribers.splice(subscriptionIndex, 1)
    }
  }

  subscribers.push(subscription)

  return subscription
}

const eventStream = {
  publish,
  subscribe
}

export default eventStream
